import { convertToH1, convertToH2, convertToH3 } from './operations';

const slashMenu = {
  'Heading 1': { icon: 'heading-1', basic: true, shortcut: '#', transform: convertToH1 },
  'Heading 2': { icon: 'heading-2', basic: true, shortcut: '##', transform: convertToH2 },
  'Heading 3': { icon: 'heading-3', basic: true, shortcut: '###', transform: convertToH3 },
};

export default slashMenu;
